import http from '@/plugins/api'
import * as types from './types'
import { startLoading } from '@/plugins/loading'
import globals from '@/plugins/globals.js'

const authUrl = window.config ? window.config.authUrl : ''

// a helper method to collect vee validation child components
function collectChildValidation($this, validations) {
  $this.$children.forEach(vm => {
    validations.push(vm.$validator.validateAll())
    if (vm.$children.length) {
      collectChildValidation(vm, validations)
    }
  })
}

export default {
  clearToken({ commit, state }) {
    commit(types.RESET_LOGIN)
  },
  setPassthrough({ commit }, passthrough) {
    commit(types.SET_PASSTHROUGH, passthrough)
  },
  async getToken({ commit, getters, dispatch }, [user, pwd]) {
    commit(types.RESET_LOGIN)
    const t = await startLoading(dispatch, 'getToken', () =>
      http.post('getToken', { user, pwd }, {}, authUrl)
    )
    commit(types.SET_TOKEN, t.data)
    if (getters.user && getters.user.prn) {
      const r = await startLoading(dispatch, 'getUserByName', () =>
        http.get('user/getUserByName', { params: { username: user } })
      )
      commit(types.SET_ROLES, r.data[0])
      const s = await startLoading(dispatch, 'getLocationKey', () =>
        http.get(`BusinessQuery/LocationById?id=${r.data[0].Location.Id}`)
      )
      commit(types.SET_LOCATION_KEY, s.data)
    }
  },
  veeValidateAll({ commit }, $this) {
    return new Promise((resolve, reject) => {
      let validations = [$this.$validator.validateAll()]
      collectChildValidation($this, validations)
      Promise.all(validations)
        .then(r => resolve(r.every(i => i === true)))
        .catch(reject)
    })
  },
  logout({ commit, state }) {
    commit(types.RESET_LOGIN)
  },
  setContact({ commit }, id) {
    commit(types.SET_CONTACT, id)
  },
  updateContact({ commit }, data) {
    commit(types.UPDATE_CONTACT, data)
  },
  async setLanguage({ commit, dispatch }, contact) {
    commit(types.SET_LANGUAGE, contact.language)
    let appId = globals.getApp()
    // If app solution not Glass, proceed...
    if (appId !== 2) {
      await startLoading(dispatch, 'setLanguage', () =>
        http.post('User/UpdateContact', contact)
      )
    }
  },
  async getLocationKey({ commit, dispatch }, id) {
    const r = await startLoading(dispatch, 'getLocationKey', () =>
      http.get(`BusinessQuery/LocationById?id=${id}`)
    )
    commit(types.SET_LOCATION_KEY, r.data)
  },
  async getBusinessUsers({ commit, dispatch, state }) {
    const r = await startLoading(dispatch, 'getBusinessUsers', () =>
      http.get(`BusinessQuery/Users?key=${state.userProfile.location.key}`)
    )
    commit(types.SET_BUSINESS_USERS, r.data)
  },
  async upsertBusinessContact({ commit, dispatch }, contact) {
    const t = await startLoading(dispatch, 'upsertBusinessContact', () =>
      http.post('Business/ModifyUsers', contact)
    )
    return t.data
  },
  async getBusinessContact({ dispatch }, contact) {
    const t = await startLoading(dispatch, 'getBusinessContact', () =>
      http.get(`BusinessQuery/BusinessContactGet?id=${contact}`)
    )
    return t.data
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/auth/actions.js